// StudentRoutes.jsx
import { Route, Routes } from "react-router-dom";
import EnrolledCourseDetailsPage from "../../Components/Dashboard/StudentDashboard/EnrolledCourseDetailsPage";
import PlacementTestMain from "../../Components/Dashboard/StudentDashboard/PlacementTestMain";
import PlacementTestRules from "../../Components/Dashboard/StudentDashboard/PlacementTestRules";
import StudentProfile from "../../Components/Dashboard/StudentDashboard/StudentProfile";
import StudentSubmissions from "../../Components/Dashboard/StudentDashboard/StudentSubmissions";
import NotFoundPage from "../../Components/Error/NotFoundPage";

const StudentRoutes = () => {
  return (
    <Routes>
      <Route path="/student/profile" element={<StudentProfile />} />
      <Route path="/dashboard/student/submissions" element={<StudentSubmissions />} />

      <Route
        path="/dashboard/enrolled-course/:teacherCourseId"
        element={<EnrolledCourseDetailsPage />}
      />
      <Route path="/placement/rules" element={<PlacementTestRules />} />
      <Route path="/placement/test" element={<PlacementTestMain />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default StudentRoutes;
